<template>
    <div class="Toast-stander" v-if="show">
        <div class="mask" @click="cancel"></div>
        <div class="content" ref="toastContent">{{text}}</div>
    </div>
</template>

<script>
    import Index from './index.js';
    export default Index;
</script>

<style lang="less">
    @import './index.less';
</style>



// WEBPACK FOOTER //
// src/ui/toast/index.vue